import { Component, OnInit } from "@angular/core";
import { DocumentsHttpService } from "src/app/services/httpServices/documentsHttpService/documents-http.service";
import { HttpErrorHandlerService } from "src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let Redoc: any;

@Component({
    selector: "app-api",
    templateUrl: "./api.component.html",
    styleUrls: ["./api.component.scss"],
})
export class ApiComponent implements OnInit {
    constructor(
        private _documentsHttpService: DocumentsHttpService,
        private _httpErrorHandlerService: HttpErrorHandlerService,
    ) {}

    ngOnInit(): void {
        this._documentsHttpService.getOpenApiSchema().subscribe(
            (data) => {
                Redoc.init(
                    data,
                    {
                        hideDownloadButton: true,
                        noAutoAuth: true,
                        sortPropsAlphabetically: true,
                        theme: {
                            logo: {
                                gutter: "10% 30%",
                            },
                        },
                    },
                    document.getElementById("redoc"),
                );
            },
            (error) => this._httpErrorHandlerService.handle(error),
        );
    }
}
